import * as React from 'react'

export default () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 23C10.7167 23 10.4792 22.9042 10.2875 22.7125C10.0958 22.5208 10 22.2833 10 22V20H23V11H25C25.2833 11 25.5208 11.0958 25.7125 11.2875C25.9042 11.4792 26 11.7167 26 12V27L22 23H11ZM6 22V8C6 7.71667 6.09583 7.47917 6.2875 7.2875C6.47917 7.09583 6.71667 7 7 7H20C20.2833 7 20.5208 7.09583 20.7125 7.2875C20.9042 7.47917 21 7.71667 21 8V17C21 17.2833 20.9042 17.5208 20.7125 17.7125C20.5208 17.9042 20.2833 18 20 18H10L6 22Z"
      fill="#8FB4FF"
    />
  </svg>
)
